import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { ANALYTICS_ACTION_CHANGED, ANALYTICS_ACTION_CLICKED, ANALYTICS_SUBJECT_MENU_ITEM, ANALYTICS_SUBJECT_ROW_ITEM, ButtonClickedEvent, CheckboxClickedEvent, LinkClickedEvent, MenuItemClickedEvent, TooltipViewedEvent } from '@atlassian/mpac-analytics';
import { CHANGE_PARTNER_REPORTS_FILTER, CHART_PATTERN_TOGGLE, CLICKED_ADDITIONAL_INSIGHTS, DISABLE_NEW_REPORTS, DISMISS_SPOTLIGHT_TOUR_ON_REPORTS, DISMISS_TOUR_ON_REPORTS, EXPAND_ROW, EXPORT_REPORT, EXPORT_REPORT_DROPDOWN_CLICK, FEEDBACK_BY_REASON_DROPDOWN, MANAGE_PARTNER_REPORTS_VIEW, OPEN_CONTACTS_EMAIL_LINK, OPEN_DATA_API_IN_NEW_TAB, OPEN_FEEDBACK_COLLECTOR_FOR_REPORTS, OPEN_REPORT_DETAILS_IN_NEW_TAB, REPORTS_TITLE_INFO_ICON, RESET_PARTNER_REPORTS_FILTER, SEE_ALL_SUMMARY_CARDS, SEND_FEEDBACK_FOR_REPORTS, START_TOUR_ON_REPORTS } from '../../analytics/Events';
export const filtersAnalyticsConfig = attributes => ({
  eventContainer: MANAGE_PARTNER_REPORTS_VIEW,
  eventType: MenuItemClickedEvent,
  actionSubjectId: CHANGE_PARTNER_REPORTS_FILTER,
  attributes: _objectSpread({}, attributes)
});
export const resetButtonAnalyticsConfig = attributes => ({
  eventContainer: MANAGE_PARTNER_REPORTS_VIEW,
  eventType: ButtonClickedEvent,
  actionSubjectId: RESET_PARTNER_REPORTS_FILTER,
  attributes: _objectSpread({}, attributes)
});
export const groupByButtonAnalyticsConfig = attributes => ({
  eventContainer: MANAGE_PARTNER_REPORTS_VIEW,
  eventType: MenuItemClickedEvent,
  actionSubjectId: CHANGE_PARTNER_REPORTS_FILTER,
  attributes: _objectSpread({}, attributes)
});
export const displayByButtonAnalyticsConfig = attributes => ({
  eventContainer: MANAGE_PARTNER_REPORTS_VIEW,
  eventType: MenuItemClickedEvent,
  actionSubjectId: CHANGE_PARTNER_REPORTS_FILTER,
  attributes: _objectSpread({}, attributes)
});
export const tableDataAnalyticsConfig = attributes => ({
  eventContainer: MANAGE_PARTNER_REPORTS_VIEW,
  eventType: LinkClickedEvent,
  actionSubjectId: CHANGE_PARTNER_REPORTS_FILTER,
  attributes: _objectSpread({}, attributes)
});
export const dataApiItemAnalyticsConfig = attributes => ({
  eventContainer: MANAGE_PARTNER_REPORTS_VIEW,
  eventType: MenuItemClickedEvent,
  actionSubjectId: OPEN_DATA_API_IN_NEW_TAB,
  attributes: _objectSpread({}, attributes)
});
export const sideNavAnalyticsConfig = attributes => ({
  eventContainer: MANAGE_PARTNER_REPORTS_VIEW,
  eventType: MenuItemClickedEvent,
  actionSubjectId: CHANGE_PARTNER_REPORTS_FILTER,
  attributes: _objectSpread({}, attributes)
});
export const seeAllSummaryCardsAnalyticsConfig = attributes => ({
  eventContainer: MANAGE_PARTNER_REPORTS_VIEW,
  eventType: ButtonClickedEvent,
  actionSubjectId: SEE_ALL_SUMMARY_CARDS,
  attributes: _objectSpread({}, attributes)
});
export const chartByAppAnalyticsConfig = attributes => ({
  eventContainer: MANAGE_PARTNER_REPORTS_VIEW,
  eventType: {
    action: ANALYTICS_ACTION_CLICKED,
    actionSubject: ANALYTICS_SUBJECT_ROW_ITEM
  },
  actionSubjectId: CHANGE_PARTNER_REPORTS_FILTER,
  attributes: _objectSpread({}, attributes)
});
export const giveFeedbackButtonAnalyticsConfig = attributes => ({
  eventContainer: MANAGE_PARTNER_REPORTS_VIEW,
  eventType: ButtonClickedEvent,
  actionSubjectId: OPEN_FEEDBACK_COLLECTOR_FOR_REPORTS,
  attributes: _objectSpread({}, attributes)
});
export const submitFeedbackButtonAnalyticsConfig = attributes => ({
  eventContainer: MANAGE_PARTNER_REPORTS_VIEW,
  eventType: ButtonClickedEvent,
  actionSubjectId: SEND_FEEDBACK_FOR_REPORTS,
  attributes: _objectSpread({}, attributes)
});
export const contactsEmailAnalyticsConfig = attributes => ({
  eventContainer: MANAGE_PARTNER_REPORTS_VIEW,
  eventType: LinkClickedEvent,
  actionSubjectId: OPEN_CONTACTS_EMAIL_LINK,
  attributes: _objectSpread({}, attributes)
});
export const startTourButtonAnalyticsConfig = attributes => ({
  eventContainer: MANAGE_PARTNER_REPORTS_VIEW,
  eventType: ButtonClickedEvent,
  actionSubjectId: START_TOUR_ON_REPORTS,
  attributes: _objectSpread({}, attributes)
});
export const dismissStartTourButtonAnalyticsConfig = attributes => ({
  eventContainer: MANAGE_PARTNER_REPORTS_VIEW,
  eventType: ButtonClickedEvent,
  actionSubjectId: DISMISS_TOUR_ON_REPORTS,
  attributes: _objectSpread({}, attributes)
});
export const dismissSpotlightTourButtonAnalyticsConfig = attributes => ({
  eventContainer: MANAGE_PARTNER_REPORTS_VIEW,
  eventType: ButtonClickedEvent,
  actionSubjectId: DISMISS_SPOTLIGHT_TOUR_ON_REPORTS,
  attributes: _objectSpread({}, attributes)
});
export const reportsMoreDetailsAnalyticsConfig = attributes => ({
  eventContainer: MANAGE_PARTNER_REPORTS_VIEW,
  eventType: LinkClickedEvent,
  actionSubjectId: OPEN_REPORT_DETAILS_IN_NEW_TAB,
  attributes: _objectSpread({}, attributes)
});
export const disableNewReportsAnalyticsConfig = attributes => ({
  eventContainer: MANAGE_PARTNER_REPORTS_VIEW,
  eventType: MenuItemClickedEvent,
  actionSubjectId: DISABLE_NEW_REPORTS,
  attributes: _objectSpread({}, attributes)
});
export const rowExpandButtonAnalyticsConfig = attributes => ({
  eventContainer: MANAGE_PARTNER_REPORTS_VIEW,
  eventType: ButtonClickedEvent,
  actionSubjectId: EXPAND_ROW,
  attributes: _objectSpread({}, attributes)
});
export const exportButtonAnalyticsConfig = attributes => ({
  eventContainer: MANAGE_PARTNER_REPORTS_VIEW,
  eventType: ButtonClickedEvent,
  actionSubjectId: EXPORT_REPORT,
  attributes: _objectSpread({}, attributes)
});
export const exportButtonDropdownClickAnalyticsConfig = attributes => ({
  eventContainer: MANAGE_PARTNER_REPORTS_VIEW,
  eventType: ButtonClickedEvent,
  actionSubjectId: EXPORT_REPORT_DROPDOWN_CLICK,
  attributes: _objectSpread({}, attributes)
});
export const additionalInsightsAnalyticsConfig = attributes => ({
  eventContainer: MANAGE_PARTNER_REPORTS_VIEW,
  eventType: CheckboxClickedEvent,
  actionSubjectId: CLICKED_ADDITIONAL_INSIGHTS,
  attributes: _objectSpread({}, attributes)
});
export const chartToggleAnalyticsConfig = attributes => ({
  eventContainer: MANAGE_PARTNER_REPORTS_VIEW,
  eventType: CheckboxClickedEvent,
  actionSubjectId: CHART_PATTERN_TOGGLE,
  attributes: _objectSpread({}, attributes)
});
export const feedbackByReasonViewAnalyticsConfig = attributes => ({
  eventContainer: MANAGE_PARTNER_REPORTS_VIEW,
  eventType: ButtonClickedEvent,
  actionSubjectId: FEEDBACK_BY_REASON_DROPDOWN,
  attributes: _objectSpread({}, attributes)
});
export const reportsTitleInfoIconAnalyticsConfig = attributes => ({
  eventContainer: MANAGE_PARTNER_REPORTS_VIEW,
  eventType: TooltipViewedEvent,
  actionSubjectId: REPORTS_TITLE_INFO_ICON,
  attributes: _objectSpread({}, attributes)
});

// To Be Added
export const reportsTableLineItemAnalyticsConfig = attributes => ({
  eventContainer: MANAGE_PARTNER_REPORTS_VIEW,
  action: ANALYTICS_ACTION_CHANGED,
  actionSubject: ANALYTICS_SUBJECT_MENU_ITEM,
  actionSubjectId: RESET_PARTNER_REPORTS_FILTER,
  attributes: _objectSpread({}, attributes)
});